module.exports = __webpack_public_path__ + "img/savings.8f33485f.svg";